/* eslint-disable */
import React, { useEffect, Fragment, useState, useCallback } from 'react'
import { AboutMissionTitleCard, AboutMissionTitle } from './about-mission'
import AboutCreative from './about-creative'
import HeroBanner from './section/hero-banner'
import { AboutLastTitle, AboutLastContent } from './about-last'
import AboutValue from './about-value'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Helmet from 'react-helmet'
import { useTranslation } from "react-i18next"

const AboutPage = () => {
  const { t } = useTranslation();
  const [isHeaderShow, setIsHeaderShow] = useState(false)
  const [nowPosition, setCurrentPosition] = useState(0)

  const trackScrolling = useCallback(() => {
    const currentScrollPos = window.pageYOffset
    // nowPosition(currentScrollPos)
    setCurrentPosition(currentScrollPos)
    if (currentScrollPos > 50) {
      setIsHeaderShow(true)
    } else {
      setIsHeaderShow(false)
    }
  }, [])
  useEffect(() => {
    document.addEventListener('scroll', trackScrolling)
    return () => {
      document.removeEventListener('scroll', trackScrolling)
    }
  }, [])

  return (
    <Fragment>
      <Helmet>
        <title>Tentang Visi dan Misi | halojasa.com</title>
        <meta charSet="utf-8" />
        <meta name="description" content="Cari tahu lebih dalam mengenai visi dan misi kami, lengkap dengan informasi profile perusahaan halojasa" />
        <meta property="og:title" content="Tentang Visi dan Misi | halojasa.com" />
        <meta property="og:site_name" content="Halo Jasa" />
        <meta property="og:description" content="Cari tahu lebih dalam mengenai visi dan misi kami, lengkap dengan informasi profile perusahaan halojasa" />
        <meta property="og:url" content="https://halojasa.com/bantuan/tentang-kami/" />
        <meta property="og:image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/tentangkami-ls.png" />
        <meta property="og:image:secure_url" content="https://halojasa.com/blog/wp-content/uploads/2020/06/tentangkami-ls.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image" itemProp="image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/tentangkami-sq.png" />
        <meta property="og:image:secure_url" itemProp="image" content="https://halojasa.com/blog/wp-content/uploads/2020/06/tentangkami-sq.png" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="300" />
        <meta property="og:image:height" content="300" />
        <meta property="og:type" content="website" />
        <meta property="fb:app_id" content="951866408583742" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@pthalojasa" />
        <meta name="twitter:title" content="Tentang Visi dan Misi | halojasa.com" />
        <meta name="twitter:description" content="Cari tahu lebih dalam mengenai visi dan misi kami, lengkap dengan informasi profile perusahaan halojasa" />
        <meta name="twitter:image:src" content="https://halojasa.com/blog/wp-content/uploads/2020/06/tentangkami-ls.png" />
        <meta name="p:domain_verify" content="4e6fcb4deba1a02d84225fad69babc0b" />
        <meta name="keyword" content="visi misi halo jasa" />
      </Helmet>

      <HeroBanner></HeroBanner>

      <AboutCreative></AboutCreative>

      <Grid>
        <Row style={{ marginTop: 90 }}>
          <Col xs={12} sm={12} md={12} lg={4}>
            <AboutMissionTitle></AboutMissionTitle>
          </Col>
          <Col xs={12} md={12} lg={8}>
            <AboutMissionTitleCard></AboutMissionTitleCard>
          </Col>
        </Row>
      </Grid>

      <AboutValue></AboutValue>

      <Grid>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12} lg={4}>
            <AboutLastTitle></AboutLastTitle>
          </Col>
        </Row>
      </Grid>
      <AboutLastContent></AboutLastContent>
    </Fragment>
  )
}

export default AboutPage
